import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

import { prepareAuthenticatedHeaders } from './utils/headers'
import { Certificates } from '../types'

export const certificatesApi = createApi({
  reducerPath: 'certificatesApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${import.meta.env.VITE_API_URL}/api/v1/certificates`,
    prepareHeaders: prepareAuthenticatedHeaders,
  }),
  tagTypes: ['Certificates'],
  endpoints: builder => ({
    listCertificates: builder.query<Certificates[], void>({
      query: () => ({
        url: '/',
      }),
    }),
  }),
})

export const { useListCertificatesQuery } = certificatesApi
